
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("UsO9m", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $0bd3576743f3d06c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $exb0h = parcelRequire("exb0h");

var $kJlBc = parcelRequire("kJlBc");

var $9EFi5 = parcelRequire("9EFi5");

var $bN0JP = parcelRequire("bN0JP");
/**
 * Manages the visibility and state of the project builder drawer based on query parameters.
 * It controls when to show the project builder drawer, especially after a condition
 * involving specific query parameters is met, ensuring it's not displayed for auto-created
 * projects or outside the project queues page. This component also handles the drawer's
 * open state and its closure action.
 */ const $0bd3576743f3d06c$var$ProjectBuilderWithQueryParam = ()=>{
    const [projectBuilderQueryParam, setProjectBuilderQueryParam] = (0, $kJlBc.useQueryParam)((0, $bN0JP.SHOW_PROJECT_BUILDER_QUERY_PARAM));
    // if it's a first, auto created, JSM project as part of X-flow from JSW
    const [autoCreateFirstJsmProject] = (0, $kJlBc.useQueryParam)('autoCreateFirstJsmProject');
    const [{ route: route }] = (0, $kJlBc.useRouter)();
    const [isDrawerOpen, setIsDrawerOpen] = (0, $eUqFw.useState)(false);
    const onClosed = (0, $eUqFw.useCallback)(()=>setIsDrawerOpen(false), []);
    (0, $eUqFw.useEffect)(()=>{
        // Show project builder only on project queues page, but not on auto-created projects
        if (projectBuilderQueryParam === 'true' && autoCreateFirstJsmProject !== '1' && (route.name === (0, $exb0h.ROUTE_NAMES).SERVICEDESK_QUEUES_LANDING || route.name === (0, $exb0h.ROUTE_NAMES).SERVICEDESK_GETTING_STARTED_PAGE)) {
            setIsDrawerOpen(true);
            setProjectBuilderQueryParam(undefined);
        }
    }, [
        autoCreateFirstJsmProject,
        projectBuilderQueryParam,
        route.name,
        setProjectBuilderQueryParam
    ]);
    if (isDrawerOpen) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9EFi5.AsyncProjectBuilderDrawer), {
        isOpenInitial: true,
        onClosed: onClosed
    });
    return null;
};
var $0bd3576743f3d06c$export$2e2bcd8739ae039 = $0bd3576743f3d06c$var$ProjectBuilderWithQueryParam;

});
parcelRegister("9EFi5", function(module, exports) {

$parcel$export(module.exports, "LazyComponent", () => $6ae11cc3f6e45a93$export$31f1740ae531af94);
$parcel$export(module.exports, "AsyncProjectBuilderDrawer", () => $6ae11cc3f6e45a93$export$54a4eade9eae9473);
$parcel$export(module.exports, "canUseProjectBuilder", () => $6ae11cc3f6e45a93$export$ff317c5d87147a19);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

var $iVSJI = parcelRequire("iVSJI");

const $6ae11cc3f6e45a93$export$31f1740ae531af94 = (0, $7rh0R.lazy)(()=>(parcelRequire("2vI6z")), {
    ssr: false,
    moduleId: "./src/packages/servicedesk/project-builder/src/index.tsx"
});
const $6ae11cc3f6e45a93$export$54a4eade9eae9473 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "bundle-async-project-builder",
        packageName: "jira-servicedesk-project-builder",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        fallback: null,
        name: "jsm-project-builder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iVSJI.ServiceDeskAnalyticsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ae11cc3f6e45a93$export$31f1740ae531af94, {
        isOpenInitial: !!props.isOpenInitial,
        ...props
    }))));
const $6ae11cc3f6e45a93$export$ff317c5d87147a19 = (isAdmin)=>isAdmin;

});
parcelRegister("iVSJI", function(module, exports) {

$parcel$export(module.exports, "ServiceDeskAnalyticsContext", () => $98f32c00711ff158$export$ac31f8f3368d6881);

var $eUqFw = parcelRequire("eUqFw");

var $8WuJm = parcelRequire("8WuJm");

var $SEaoU = parcelRequire("SEaoU");

var $kJ81T = parcelRequire("kJ81T");
const $98f32c00711ff158$export$ac31f8f3368d6881 = ({ useContainerContext: useContainerContext, useServiceDeskAnalyticsContext: useServiceDeskAnalyticsContext, children: children, forceRenderWhileLoading: forceRenderWhileLoading })=>{
    const [{ data: containerContextData, loading: containerContextLoading }] = useContainerContext();
    const { data: analyticsContextAttributes, error: analyticsContextError, loading: analyticsContextLoading } = useServiceDeskAnalyticsContext();
    if ((0, $eUqFw.Children).count(children) > 0) {
        const loading = containerContextLoading || analyticsContextLoading;
        const shouldRenderChildren = !loading || loading && forceRenderWhileLoading || !!analyticsContextError;
        if (!shouldRenderChildren) return null;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const context = {};
        // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
        if (containerContextData && containerContextData.project) {
            // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
            const { id: id, type: type } = containerContextData.project;
            // containerType and containerId are obsolete - See https://developer.atlassian.com/platform/analytics-pipeline/getting-started/event-types/#glossary-of-terms
            // Also these dont work with screen events. See sendScreenEvent in: https://bitbucket.org/atlassian/analytics-web-client/src/master/src/analyticsWebClient.js
            // However they are kept here to not break any existing usages.
            context.containerType = 'project';
            context.containerId = `${id}`;
            // This is the preferred way to send container data for analytics
            context.containers = {
                project: {
                    id: `${id}`,
                    type: type
                }
            };
            if (analyticsContextAttributes && !analyticsContextError) context.attributes = analyticsContextAttributes;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), context, children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
};
$98f32c00711ff158$export$ac31f8f3368d6881.defaultProps = {
    forceRenderWhileLoading: false,
    useServiceDeskAnalyticsContext: (0, $kJ81T.useServiceDeskAnalyticsContext),
    useContainerContext: (0, $SEaoU.useContainerContext)
};

});
parcelRegister("SEaoU", function(module, exports) {

$parcel$export(module.exports, "useContainerContext", () => $753bd1908e635680$export$c7066c2d215990cf);
$parcel$export(module.exports, "ContainerContextSubscriber", () => $753bd1908e635680$export$5b87a78c45d5dd17);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $4MmfV = parcelRequire("4MmfV");
var $kXWpU = parcelRequire("kXWpU");

var $3HCkE = parcelRequire("3HCkE");

var $e8UKN = parcelRequire("e8UKN");
const $753bd1908e635680$var$useProjectContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $3HCkE.useResource)((0, $kXWpU.staticProjectSidebarNavigationResource));
    const projectContext = (0, $eUqFw.useMemo)(()=>data && (0, $e8UKN.getProjectContext)(data), [
        data
    ]);
    return [
        {
            data: projectContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $753bd1908e635680$var$useUserBoardContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $3HCkE.useResource)((0, $4MmfV.staticJSWUserBoardSidebarNavigationResource));
    const userContext = (0, $eUqFw.useMemo)(()=>data && (0, $e8UKN.getUserContext)(data), [
        data
    ]);
    return [
        {
            data: userContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $753bd1908e635680$export$c7066c2d215990cf = ()=>{
    const projectContext = $753bd1908e635680$var$useProjectContext();
    const userBoardContext = $753bd1908e635680$var$useUserBoardContext();
    if (userBoardContext && userBoardContext[0] && userBoardContext[0].data != null) return userBoardContext;
    return projectContext;
};
const $753bd1908e635680$export$5b87a78c45d5dd17 = (props)=>{
    const [data, actions] = $753bd1908e635680$export$c7066c2d215990cf();
    // @ts-expect-error - TS2345 - Argument of type '{ readonly data: ContainerContext | null; readonly error: Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null; readonly loading: boolean; }' is not assignable to parameter of type 'ContainerContextData'.
    return props.children(data, actions);
};
$753bd1908e635680$export$5b87a78c45d5dd17.displayName = 'ContainerContextSubscriber';

});
parcelRegister("e8UKN", function(module, exports) {

$parcel$export(module.exports, "getUserContext", () => $4c7bf04e2602d89a$export$114c35c2c23732ab);
$parcel$export(module.exports, "getProjectContext", () => $4c7bf04e2602d89a$export$d17fffd59c7b3c60);

var $7ZZxN = parcelRequire("7ZZxN");

var $eWsAG = parcelRequire("eWsAG");
const $4c7bf04e2602d89a$export$114c35c2c23732ab = (userBoardNavData)=>{
    const { boardInfo: boardInfo, owner: owner } = userBoardNavData;
    return {
        contextType: 'user',
        user: {
            id: owner.id,
            name: owner.name,
            avatarUrl: owner.avatarUrl,
            profileUrl: owner.profileUrl,
            accountId: owner.accountId
        },
        scope: {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        }
    };
};
const $4c7bf04e2602d89a$var$getScope = (projectNavInfo)=>{
    if (projectNavInfo.projectType === 'jira_software' && projectNavInfo?.jiraSoftwareNavData?.boardInfo) {
        const { boardInfo: boardInfo } = projectNavInfo.jiraSoftwareNavData;
        return {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        };
    }
    return undefined;
};
const $4c7bf04e2602d89a$var$getProjectType = (projectType)=>{
    switch(projectType){
        case 'business':
            return 0, $7ZZxN.CORE_PROJECT;
        case 'software':
            return 0, $7ZZxN.SOFTWARE_PROJECT;
        case 'service_desk':
            return 0, $7ZZxN.SERVICE_DESK_PROJECT;
        case 'product_discovery':
            return 0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT;
        default:
            return null;
    }
};
const $4c7bf04e2602d89a$export$d17fffd59c7b3c60 = (projectNavInfo)=>{
    const project = (0, $eWsAG.extractData)(projectNavInfo);
    const scope = $4c7bf04e2602d89a$var$getScope(projectNavInfo);
    if (project) {
        const projectType = $4c7bf04e2602d89a$var$getProjectType(project.type);
        if (projectType) return {
            contextType: 'project',
            project: {
                key: project.key,
                // @ts-expect-error TS2322: Type 'number' is not assignable to type 'string'
                id: project.id,
                name: project.name,
                type: projectType,
                isSimplified: project.isSimplified,
                avatarUrl: project.avatarUrl,
                style: (0, $eWsAG.getStyle)(project.isSimplified)
            },
            scope: scope
        };
    }
    return null;
};

});



parcelRegister("2vI6z", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('dsiAd'),
            load('ekVbM'),
            load('92sUi'),
            load('i5RRW'),
            load('561Jq'),
            load('1QYl5'),
            load('2hmUs'),
            load('bCeK4'),
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('iYygF')
        ]);
        const value = parcelRequire('8Zm1o');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("dsiAd"),
        load("ekVbM"),
        load("92sUi"),
        load("i5RRW"),
        load("561Jq"),
        load("1QYl5"),
        load("2hmUs"),
        load("bCeK4"),
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("iYygF")
    ]).then(()=>parcelRequire('8Zm1o'));
}

});


parcelRegister("bN0JP", function(module, exports) {

$parcel$export(module.exports, "SHOW_PROJECT_BUILDER_QUERY_PARAM", () => $d990083b1b77fb66$export$ca06930325b64075);
$parcel$export(module.exports, "SHOW_PROJECT_BUILDER_QUERY_PARAM_DEV", () => $d990083b1b77fb66$export$bdaa4b82186a5b44);
$parcel$export(module.exports, "BLANK_PROJECT_TEMPLATES", () => $d990083b1b77fb66$export$26b62c0869751109);
const $d990083b1b77fb66$export$ca06930325b64075 = 'showProjectBuilder';
const $d990083b1b77fb66$export$bdaa4b82186a5b44 = 'showProjectBuilderDev';
const $d990083b1b77fb66$export$26b62c0869751109 = [
    'com.atlassian.servicedesk:simplified-blank-project-it',
    'com.atlassian.servicedesk:simplified-blank-project-business',
    'com.atlassian.servicedesk:company-managed-blank-service-project',
    'com.atlassian.servicedesk:team-managed-blank-service-project'
];

});



//# sourceMappingURL=async-service-project-builder.114a665c.js.map
